import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TemplateEntityEditingModal from 'components/views/admin/templates/single/templateEntityEditingModal/component';
import CompanyForm from 'components/views/admin/templates/single/companies/companyForm/component';
import TemplateConfirmationModal from 'components/views/admin/templates/templateConfirmationModal/component';
import { adminRemoveCompanyAction, adminUpdateCompanyAction } from '../../../../../../redux/actions/admin/admin.company.actions';
export default function CompanyListing() {
    var dispatch = useDispatch();
    var template = useSelector(function (state) { return state.admin.singleTemplate; });
    var _a = useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var _b = useState(false), confirmModalOpen = _b[0], setConfirmModalOpen = _b[1];
    var _c = useState(null), openId = _c[0], setOpenId = _c[1];
    function onCompanyModify(id) {
        setModalOpen(true);
        setOpenId(id);
    }
    function onCompanyConfirmDelete() {
        dispatch(adminRemoveCompanyAction(openId, template._id));
        setOpenId(null);
        setConfirmModalOpen(false);
    }
    function onCompanyDeleteClick(id) {
        setOpenId(id);
        setConfirmModalOpen(true);
    }
    function onConfirmModalClose() {
        setOpenId(null);
        setConfirmModalOpen(false);
    }
    function onModalClose() {
        setOpenId(null);
        setModalOpen(false);
    }
    if (!template)
        return null;
    return (React.createElement("div", null,
        React.createElement("ul", { className: "list-styles-clear" }, template.companies.map(function (company, index) {
            var _a, _b, _c;
            return (React.createElement("li", { className: "mar-bottom-5 mar-top-5", key: company._id },
                React.createElement("span", { style: { display: 'inline-block', width: 300 } },
                    index + 1,
                    ".)\u00A0", (_c = (_b = (_a = company.name) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '',
                    company.isBank && '(Bank)',
                    !company.visibility && '(Nähtamatu)'),
                React.createElement("button", { className: "main-button mar-left-10 mar-right-10", onClick: function () { return onCompanyModify(company._id); } }, "Muuda"),
                React.createElement("button", { className: "main-button main-button--error", onClick: function () { return onCompanyDeleteClick(company._id); } }, "Kustuta")));
        })),
        React.createElement("button", { className: "main-button", onClick: function () { return setModalOpen(true); } }, "Add company"),
        React.createElement(TemplateEntityEditingModal, { stageEditModalOpen: modalOpen, onModalClose: onModalClose },
            React.createElement(CompanyForm, { company: template.companies.find(function (c) { return c._id === openId; }), onModalClose: onModalClose })),
        React.createElement(TemplateConfirmationModal, { modalOpen: confirmModalOpen, onModalClose: onConfirmModalClose },
            React.createElement("div", null,
                React.createElement("h2", null,
                    "Oled kindel et soovid kustutada firma ",
                    getCompanyTitle(openId, template.companies),
                    "?"),
                React.createElement("div", { className: "d-flex mar-top-20 justify-content-center flex-gap-10" },
                    React.createElement("button", { className: "main-button", onClick: onConfirmModalClose }, "Sulge"),
                    React.createElement("button", { className: "main-button main-button--error", onClick: onCompanyConfirmDelete }, "Kinnita"))))));
}
function getCompanyTitle(id, companies) {
    var _a, _b, _c;
    var company = companies.find(function (c) { return c._id === id; });
    return (_c = (_b = (_a = company === null || company === void 0 ? void 0 : company.name) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
}
